import { createContext, useContext, useMemo, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

export enum LANGUAGES {
    FRENCH = 'fr',
    ENGLISH = 'en',
}

interface LanguageContextType {
    language: LANGUAGES;
    switchLanguageHref: string;
}

const LanguageContext = createContext<LanguageContextType>({
    language: LANGUAGES.FRENCH,
    switchLanguageHref: '/en',
});

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
    const location = useLocation();
    const isEnglish = location.pathname.startsWith('/en');
    const language = isEnglish ? LANGUAGES.ENGLISH : LANGUAGES.FRENCH;
    const switchLanguageHref = isEnglish ? '/' : '/en';

    const value = useMemo(() => ({ language, switchLanguageHref }), [language, switchLanguageHref]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    return useContext(LanguageContext);
};
